import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import cookie from 'react-cookie';
import moment from 'moment';
import { Meta } from 'common/components/meta';
import { TYPE_WARNING, TYPE_ERROR } from 'common/ducks/banner';
import { fetchEliteWarningsRequest } from 'common/ducks/user';
import { DISMISSED_USERNAME_BANNER_COOKIE } from 'your_projects/constants';
import { isUsernameGenerated } from 'account/utils';
import Gallery from 'your_projects/containers/gallery';
import ProjectLink from 'common/containers/project_link';

export default class YourProjects extends Component {
  componentDidMount() {
    const { user, fetchCounts, fetchIndustriesIfNeeded, params } = this.props;

    fetchIndustriesIfNeeded();
    fetchCounts(params.userType, params.projectType);

    if (user.is_client) {
      this.showClientBanners();
    } else if (user.is_creative) {
      fetchEliteWarningsRequest(user.id).then(({ data }) => this.showCreativeBanners(data));
    }

    this.redirectIfNeeded();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.redirectIfNeeded();
    }
  }

  showCreativeBanners(eliteWarnings) {
    const { user, showBanner, hideBanner } = this.props;
    let content, type = TYPE_WARNING;

    if (!user.allowed_to_participate || (user.permitted_sub_category_ids || []).length === 0) {
      content = (
        <span>
          Your <Link to="/account/id-verification/" onClick={hideBanner}>account verification
          </Link> is pending review. You cannot participate in any projects until your account
          is verified.
        </span>
      );
    } else if (eliteWarnings.length > 0) {
      const warning = eliteWarnings[0];
      type = TYPE_ERROR;

      if (warning.type === 'no_entries_in_24h') {
        content = (
          <span>
            We require each participant
            in <ProjectLink project={warning.project} onClick={hideBanner}>an Elite project
            </ProjectLink> to submit their first entry within 24 hours. If you don't submit
            your first entry in the next 6 hours, you may lose your Elite status.
          </span>
        );
      } else if (warning.type === 'less_than_4_entries_with_24h_remaining') {
        content = (
          <span>
            We require at least 4 entries per participant
            in <ProjectLink project={warning.project} onClick={hideBanner}>
            an Elite project</ProjectLink> and you have fewer than 4 entries. If you do not meet
            or exceed this minimum, you will lose your Elite status.
          </span>
        );
      }
    }

    if (content) {
      showBanner('Attention', content, undefined, type);
    }
  }

  showClientBanners() {
    const { user, showBanner, hideBanner, resendValidationEmail } = this.props;
    const usernameBannerDismissed = cookie.load(DISMISSED_USERNAME_BANNER_COOKIE);
    let content = null, onHide = null, type = TYPE_WARNING;

    /* email not validated: shown until email is validated */
    if (!user.is_email_validated) {
      type = TYPE_ERROR;
      const onLinkClick = () => {
        resendValidationEmail();
        showBanner('Validation email sent', 'Please check your inbox.');
      };
      content = (
        <span>
          You will not receive notifications from us until your email is verified.
          Please be sure to verify your email by clicking the verification link we emailed you.
          <a onClick={onLinkClick}>
            {' '}Click here to receive the verification link again.
          </a>
        </span>
      );
    /* generated username: shown until dismissed or username set */
    } else if (isUsernameGenerated(user.username) && !usernameBannerDismissed) {
      onHide = () => {
        cookie.save(
          DISMISSED_USERNAME_BANNER_COOKIE, true,
          { path: '/', expires: moment('2100-12-12').toDate() }
        );
      };
      content = (
        <span>
          You have a generic username, { user.username }.
          Take 9 seconds and create a custom one. Creatives pay more attention to new
          projects when there is
          personalization. <Link to="/account/info/" onClick={hideBanner}>Change your username</Link>.
        </span>
      );
    }

    if (content) {
      showBanner('Attention', content, undefined, type, onHide);
    }
  }

  redirectIfNeeded() {
    const { params, user, router } = this.props;
    const shouldRedirect = (
      !params.userType || !params.projectType || (!user.is_client && params.userType === 'client') ||
      (!user.is_creative && params.userType === 'creative')
    );

    if (shouldRedirect) {
      let path = 'creative/watchlist';
      if (user.is_client && !(user.is_creative && params.userType === 'creative')) {
        path = 'client/drafts';
        if (user.projects_owned_awarded > 0) {
          path = 'client/wrapup';
        } else if (user.projects_owned_active > 0) {
          path = 'client/active';
        }
      }
      router.replace(`/your-projects/${path}/`);
    }
  }

  render() {
    const { params: { userType, projectType } } = this.props;

    return (
      <div id="content" className="l-content">
        <Meta title="Your projects" />
        { !!userType && !!projectType &&
        <Gallery userType={userType} projectType={projectType}
          key={`${userType}_${projectType}`} /> }
      </div>
    );
  }
}

YourProjects.propTypes = {
  user: PropTypes.object.isRequired,
  router: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  showBanner: PropTypes.func.isRequired,
  hideBanner: PropTypes.func.isRequired,
  resendValidationEmail: PropTypes.func.isRequired,
  fetchCounts: PropTypes.func.isRequired,
  fetchIndustriesIfNeeded: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./your_projects/components/index.jsx